import React from "react";
import "./index.scss";

type Props = {
    onClick: () => void
};

export const HamburgerMenu = (props: Props) => {
    const {onClick} = props;

    const onMenuClick = (event: React.FormEvent<HTMLButtonElement>) => {
        onClick();
        onMenuClickAnimation(event.currentTarget);
    }

    const onMenuClickAnimation = (menuBtn: HTMLButtonElement) => {
        menuBtn.classList.toggle("is--active");
        menuBtn.classList.add("is--clicked");
        setTimeout(function () {
            menuBtn.classList.remove("is--clicked");
        }, 300);
    }

    return (
        <button className="hamburger-menu" aria-labelledby="sr-only" onClick={onMenuClick}>
            <span className="sr-only" id="sr-only">Menu</span>
            <div className="hamburger-menu__icon" aria-hidden="true">
            <span className="hamburger-icon hamburger-icon--menu">
              <span/>
              <span/>
              <span/>
            </span>
                <span className="hamburger-icon hamburger-icon--close">
              <span/>
              <span/>
            </span>
            </div>
        </button>
    )
}